import {
    fetchIO,
    IUser,
    IUserIO,
    IMapInfo,
    IMapInfoZ,
    Inspire,
    InspireIO,
    FeatureCollection,
    IMapBaseLayer,
    IMapBaseLayerIO,
    fetchWithoutValidationIO,
    IAliasCollection,
    IAliasCollectionIO,
    ILayerInfoIO,
    ILayerInfo,
} from 'sdi/source';

import * as io from 'io-ts';

export const fetchUser = (url: string): Promise<IUser> => fetchIO(IUserIO, url);

export const fetchMap = (url: string): Promise<IMapInfo> =>
    fetchIO(IMapInfoZ, url);

export const fetchLayers = (url: string): Promise<ILayerInfo[]> =>
    fetchIO(io.array(ILayerInfoIO), url);

export const fetchBaseLayerAll = (url: string): Promise<IMapBaseLayer[]> =>
    fetchIO(io.array(IMapBaseLayerIO), url);

export const fetchBaseLayer = (url: string): Promise<IMapBaseLayer> =>
    fetchIO(IMapBaseLayerIO, url);

export const fetchDatasetMetadata = (url: string): Promise<Inspire> =>
    fetchIO(InspireIO, url);

export const fetchAlias = (url: string): Promise<IAliasCollection> =>
    fetchIO(IAliasCollectionIO, url);

export const fetchLayer = (url: string): Promise<FeatureCollection> =>
    fetchWithoutValidationIO(url);
